import { Dialog } from "primereact/dialog";

import { SummaryLogsProps } from "./summaryLogsConsts";
import { TransferLogs } from "../../../lich-su-truyen-nhan/component/TransferLogs";

export const SummaryLog = ({
  open,
  onHide,
  invoiceSummaryData,
}: SummaryLogsProps) => {
  return (
    <Dialog
      header='Lịch sử truyền nhận'
      onHide={onHide}
      visible={open}
      style={{ maxWidth: "1000px" }}
    >
      {open && invoiceSummaryData && (
        <TransferLogs type='Summary' idAction={invoiceSummaryData.id} />
      )}
    </Dialog>
  );
};
